import store from "@/store";
import AlertModel from "@/models/AlertModel";
import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule,
} from "vuex-module-decorators";

export interface IApplicationState {
  alert: AlertModel;
}
@Module({ dynamic: true, store, name: "application" })
class Application extends VuexModule implements IApplicationState {
  alert = new AlertModel();

  @Mutation
  private DISMISS_ALERT() {
    this.alert.alertState = false;
  }

  @Mutation
  private SET_ALERT(alert: AlertModel) {
    this.alert = alert;
  }

  @Action
  public showAlert(alert: AlertModel) {
    this.SET_ALERT(alert);
  }

  @Action
  public dismissAlert() {
    this.DISMISS_ALERT();
  }
}
export const ApplicationModule = getModule(Application);
